<script setup lang="ts">
import { ref, computed, watch, toRef } from 'vue';
import { formatDistanceToNow } from "date-fns";
import { fr, tr } from "date-fns/locale";
import { useClaimStore, useNotificationStore } from '@/store';
import { CogIcon, ArrowTopRightOnSquareIcon, EnvelopeIcon, ScaleIcon } from '@heroicons/vue/24/solid';

import adminAPI from '../../services/api';
import { isValidEmail } from "@/utils";
import openBoxFolderForCurrentClaim, { openBoxSharedFolderForCurrentClaim } from "../../utils/open-box-folder";
import DotLegalStep from '../ui/badges/DotLegalStep.vue';
import { storeToRefs } from 'pinia';
import { computedAsync } from '@vueuse/core';
import BoxFilePicker from '../Box/BoxFilePicker.vue';
import { FileSignatureIcon } from 'lucide-vue-next';
import BaseInput from '../ui/inputs/BaseInput.vue';
import BaseButton from '../ui/buttons/BaseButton.vue';
import { BadgeCheckIcon } from 'lucide-vue-next';
import LoaderButton from '../ui/loaders/LoaderButton.vue';
import { InfoIcon } from 'lucide-vue-next';
import SelectCompetentCourt from '../ui/select/SelectCompetentCourt.vue';
import Select from '../ui/select/Select.vue';
import { RetrieveClaimWithRelationsResponse } from '@/interfaces';

const procedureTypesOptions = [
  { value: "PROCEDURE_CLASSIQUE", label: "Procédure Classique" },
  { value: "ESCP", label: "Règlement Européen des Petits Litiges" },
]

const selectedCourt = ref();
const selectedProcedureType = ref("PROCEDURE_CLASSIQUE" as const);
const isSubmitting = ref(false);

const props = defineProps<{claim: RetrieveClaimWithRelationsResponse}>();
const claim = toRef(props, 'claim');



async function initClaimProcedure() {
  if (!selectedCourt.value) {
    useNotificationStore().emitNotification({ title: "Veuillez sélectionner un tribunal", type: "warning" });
    return;
  };
  isSubmitting.value = true;
  try {
    console.log(`{
      juridictionId: selectedCourt.value,
      procedureType: selectedProcedureType.value.value || "PROCEDURE_CLASSIQUE",
    }`, {
      juridictionId: selectedCourt.value,
      procedureType: selectedProcedureType.value
    })
    await adminAPI.initClaimProcedure(useClaimStore().claim.id, {
      juridictionId: selectedCourt.value.value,
      procedureType: selectedProcedureType.value || "PROCEDURE_CLASSIQUE",
    });
    await useClaimStore().refreshClaim()
    useNotificationStore().emitNotification({ title: "Procédure initialisée avec succès" }); 
  } catch (error) {}
  finally {
    isSubmitting.value = false;
  }
}
</script>
<template>
<div class="border-b bg-slate-50">
  <div class="max-w-lg py-5 mx-auto text-left">
    <div class="p-8 bg-white border rounded-md shadow">
      <h2 class="inline-flex text-base font-semibold leading-6 text-gray-900 align-middle">
        <!-- <div class="flex-none p-0.5 bg-red-400/30 rounded-full"><div class="h-1.5 w-1.5 rounded-full bg-red-500"></div></div> -->
        <div class="py-1 mr-2"><DotLegalStep :legal-step-name="claim.claimLegalStep.name" /></div>
        Action requise
      </h2>
      <p class="mt-2 text-sm text-gray-500">Initialiser la procédure, pour pouvoir ensuite générer l'assignation.</p>

      <div class="relative block text-sm">
        <h3 class="mb-2 font-medium leading-7 text-gray-900"></h3>
        <div class="py-2 my-3 mt-4">
          <SelectCompetentCourt :claim-id="claim.id" v-model="selectedCourt" />
          <Select
            label="Type de procédure" 
            @update:modelValue="selected => selectedProcedureType = selected.value"
            :options="procedureTypesOptions"
          />
          <div class="mt-3">
            <BaseButton text="Initialiser la procédure" @click="initClaimProcedure" :loading="isSubmitting" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>